import { connect } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { LocalForm, Control, actions } from 'react-redux-form'
import InputErrors from 'components/input-errors'
import Auth from 'endpoints/auth'
import { loginUser } from 'app/action-creators'
import { isPresent } from 'app/validators'

class Index extends React.PureComponent {
  constructor() {
    super();
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(form) {
    Auth.login(form).then(
      ({ jwt, user }) => {
        this.props.loginUser(jwt, user);
        this.props.history.replace('/');
      },
      () => {
        this.formDispatch(actions.setValidity('local.login', { invalid_login: false }, { async: true }))
      }
    );
  }

  render() {
    return (
      <div className="container">
        <div className="row">
          <div className="col col-md-6 offset-md-3">
            <LocalForm
              getDispatch={dispatch => this.formDispatch = dispatch}
              initialState={{ login: '', password: '' }}
              onSubmit={this.onSubmit}
              className="login-form"
            >
              <h2><Translate value="login.title" /></h2>
              <div className="form-group">
                <label><Translate value="attrs.login" /></label>
                <Control type="text" model=".login" className="form-control" validators={{ presence: isPresent }} />
                <InputErrors model=".login" messages={['presence', 'invalid_login']} />
              </div>
              <div className="form-group">
                <label><Translate value="attrs.password" /></label>
                <Control type="password" model=".password" className="form-control" validators={{ presence: isPresent }} />
                <InputErrors model=".password" messages={['presence']} />
              </div>
              <button type="submit" className="btn btn-primary">
                <Translate value="form.submit" />
              </button>
            </LocalForm>
          </div>
        </div>
      </div>
    )
  }
}

export default connect(null, { loginUser })(Index);
